import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import NotificationDto from '../dto/NotificationDto';

class NotificationTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'dashboardNotificationTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<NotificationDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, NotificationDto)))
				.catch(reject);
		});
	}
}

export default new NotificationTableService();
